<template>
  <svg
    width="14px"
    height="13px"
    viewBox="0 0 14 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>返回</title>
    <desc>Created with Sketch.</desc>
    <g id="订单" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        id="1-2-订单中心-整车详情"
        transform="translate(-270.000000, -224.000000)"
        fill="#999999"
        fill-rule="nonzero"
      >
        <g id="编组-2" transform="translate(270.000000, 220.000000)">
          <path
            d="M12.6626157,9.48707692 L7.13584645,3.924 C7.01338491,3.80092308 6.85338491,3.74184615 6.6940003,3.74307692 C6.67246183,3.74123077 6.6540003,3.73076923 6.63246183,3.73076923 C6.54261568,3.73076923 6.45892337,3.75169231 6.3820003,3.78615385 C6.30446183,3.81569231 6.23061568,3.86061538 6.16784645,3.92338462 L1.18076953,8.90184615 C0.940154141,9.14184615 0.939538757,9.53138462 1.18015414,9.772 C1.30015414,9.89261538 1.4576926,9.95292308 1.61584645,9.95292308 C1.77338491,9.95292308 1.93030799,9.89261538 2.05092337,9.77323077 L6.01707722,5.81323077 L6.01707722,16.6538462 C6.01707722,16.9941538 6.29276953,17.2692308 6.63246183,17.2692308 C6.97215414,17.2692308 7.24784645,16.9941538 7.24784645,16.6538462 L7.24784645,5.78307692 L11.7900003,10.3547692 C11.9100003,10.4753846 12.0687695,10.5363077 12.226308,10.5363077 C12.3838464,10.5363077 12.5401541,10.4766154 12.6601541,10.3572308 C12.9020003,10.1178462 12.9026157,9.72769231 12.6626157,9.48707692 Z"
            id="返回"
            transform="translate(6.921040, 10.500000) rotate(-90.000000) translate(-6.921040, -10.500000) "
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BackArrow'
});
</script>
